import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { BatchType } from "../../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { batchTypeArraysMap, OrderFrequencyArraysMap } from "../../Resource/Contents";
import { dateParser, IReviewProps } from "../ReviewParser";

export const SwitchOrderSetupReview = (props: IReviewProps) => {
    const { data } = props;

    const checkNone = (config) => {
        return typeof config.data != "boolean";
    };
    const orderSetupConfig = () => {
        if (!data) {return [];}
        const config = [
            {
                title: "Batch type",
                data: batchTypeArraysMap[BatchType.OneOff],
            },
            {
                title: "Action date",
                data: dateParser(data?.Contribution?.SwitchInstructionModel?.ActionDate),
            }
        ];
        return config.filter(checkNone);
    };

    return <Typography config={orderSetupConfig()} type="common" />;
};
